module.exports = __webpack_public_path__ + "static/media/da-DK.b1a3d0f5.md";